/// <amd-module name="VSS/Features/Markdown/Utils/MarkdownItUtils" />
import * as MarkdownIt from "markdown-it";

export function getEncodedHeaderText(mdInstance: MarkdownIt.MarkdownIt, content: string): string {
    // Replacing space with dash, converting to lower case and then encoding for the url
    return encodeURIComponent(getTitleFixedWithSpaceAndCasing(mdInstance, content));
}

export function getTitleFixedWithSpaceAndCasing(mdInstance: MarkdownIt.MarkdownIt, content: string): string {
    // Using unicode library definition of space
    const separatorRx = new RegExp((mdInstance.utils as any).lib.ucmicro.Z.source, "g");
    // Note that this is a simple implementation relying on customer to have unique header names
    // Note that toLowerCase is needed for IE11 which is case-sensitive
    return content.replace(separatorRx, "-").toLowerCase();
}
